import { tipoAfiliadoLabel } from "@/lib/affiliateEstados";
import { Chip, DetailSection, EmptyLine, InfoRow } from "./AfiliadoDetailBits";
import type { Afiliado, AfiliadoDisponibilidad } from "@/types";

interface AfiliadoResumenProps {
  afiliado: Afiliado;
  disponibilidad: AfiliadoDisponibilidad[];
}

export default function AfiliadoResumen({ afiliado, disponibilidad }: AfiliadoResumenProps) {
  const isEmpresa = afiliado.tipo === "empresa";
  const general = disponibilidad.find((item) => !item.vehicle_id) ?? null;

  return (
    <div className="space-y-5">
      <DetailSection title="Información personal / contacto" icon="ri-user-line">
        <dl>
          <InfoRow label="Tipo de afiliado" value={tipoAfiliadoLabel(afiliado.tipo)} />
          {isEmpresa ? (
            <>
              <InfoRow label="Nombre comercial" value={afiliado.empresa_nombre_comercial} />
              <InfoRow label="Razón social" value={afiliado.empresa_razon_social} />
              <InfoRow label="RNC" value={afiliado.rnc} />
              <InfoRow label="Persona de contacto" value={afiliado.contacto_nombre} />
              <InfoRow label="Cargo" value={afiliado.contacto_cargo} />
            </>
          ) : (
            <>
              <InfoRow label="Nombre completo" value={afiliado.nombre_completo} />
              <InfoRow label="Cédula / ID" value={afiliado.cedula} />
              <InfoRow label="Participa como" value={afiliado.rol_vehiculo} />
            </>
          )}
          <InfoRow label="Teléfono" value={afiliado.telefono} />
          <InfoRow label="WhatsApp" value={afiliado.whatsapp} />
          <InfoRow label="Correo" value={afiliado.email} />
          <InfoRow label="Provincia" value={afiliado.provincia} />
          <InfoRow label="Ciudad" value={afiliado.ciudad} />
          <InfoRow label="Dirección / zona" value={afiliado.direccion_zona} />
          {isEmpresa && <InfoRow label="Sitio web" value={afiliado.sitio_web} />}
          {isEmpresa && <InfoRow label="Redes sociales" value={afiliado.redes} />}
        </dl>
      </DetailSection>

      <DetailSection title="Servicios que ofrece" icon="ri-service-line">
        {(afiliado.servicios ?? []).length === 0 ? (
          <EmptyLine>No indicó servicios.</EmptyLine>
        ) : (
          <div className="flex flex-wrap gap-2">
            {(afiliado.servicios ?? []).map((servicio) => (
              <Chip key={servicio} tone="accent">
                {servicio}
              </Chip>
            ))}
          </div>
        )}
      </DetailSection>

      <DetailSection title="Disponibilidad general" icon="ri-time-line">
        {!general && !afiliado.ciudad ? (
          <EmptyLine>Sin disponibilidad registrada.</EmptyLine>
        ) : (
          <dl>
            <InfoRow label="Zona de operación" value={general?.zona ?? afiliado.direccion_zona} />
            <InfoRow label="Días" value={general?.dias} />
            <InfoRow label="Horario" value={general?.horario} />
            <InfoRow label="Distancia máxima" value={general?.distancia_maxima} />
          </dl>
        )}
      </DetailSection>
    </div>
  );
}